module.exports = __webpack_public_path__ + "img/18_fineStaff_lxr.67ac337a.png";